import { createContext, useContext } from "react";
import { C8AttributeId, C8NodeType } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";
import { RefStoreBase } from "./RefStoreBase";

export class RefStore extends RefStoreBase {
	constructor(attributeId: C8AttributeId, nodeType: C8NodeType, nodeUrl: cnl, reportOperations: string) {
		super(attributeId, nodeType, nodeUrl, reportOperations);
	}
}

export const RefStoreContext = createContext<RefStore>(undefined);
export const useRefStore = (): RefStore => useContext(RefStoreContext);